import { useContaStore } from "features/conta/store";
import moment from "moment";
import { useEffect, useCallback } from "react";
import { ContaFiltroType } from "features/conta/typings";
import { parseQueryString } from "../utils";
import { useLocation } from 'react-router';

export function useContentConta() {
  const { update } = useContaStore();
  const location = useLocation();

  const updateState = useCallback(() => {
    const query = parseQueryString();
    const pago = query.status ? (query.status === "pago" ? true : false) : null;

    const result: Partial<ContaFiltroType> = {
      pago,
      acordo: null,
      atraso: null,
    };

    if (query.ano && query.mes) {
      const data = moment(`${query.ano}-${query.mes}-01`);

      result.dataInicio = data.format("YYYY-MM-DD");
      result.dataFim = data.endOf("month").format("YYYY-MM-DD");
    } else if (query.ano) {
      const data = moment(`${query.ano}-01-01`);

      result.dataInicio = data.format("YYYY-MM-DD");
      result.dataFim = data.endOf("year").format("YYYY-MM-DD");
    }

    update(result);
  }, [update]);

  useEffect(() => {
    updateState();
  }, [location, updateState]);
}
